import * as React from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';

const CustomBottomNavigation = (props) => {
    return <BottomNavigation {...props} />;
};

export { CustomBottomNavigation as BottomNavigation };
